export enum LOCALSTORAGE_KEYS{
    MARATHON= 'marathon_session_token',
}
